module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "padding": "unset"
    }
  }, [_c('div', {
    staticClass: "single_pro_view"
  }, [_c('div', {
    staticClass: "pro_image_slider"
  }, [_c('VueSlickCarousel', _vm._b({}, 'VueSlickCarousel', _vm.settings, false), _vm._l((_vm.productData.images), function(image) {
    return _c('div', {
      key: image.id,
      staticClass: "iimg"
    }, [_c('img', {
      attrs: {
        "src": image.thumbnail
      }
    })])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "pro_details"
  }, [_c('div', {
    staticClass: "pro_databox"
  }, [_c('p', {
    staticClass: "pc_name"
  }, [_vm._v(_vm._s(_vm.productData == null ? "" : _vm.productData.name))]), _vm._v(" "), _c('p', {
    staticClass: "pc_cata"
  }, [_vm._v("Category  : " + _vm._s(_vm.productData == null ? "" : _vm.productData.category.name))]), _vm._v(" "), _c('div', {
    staticClass: "pc_disc",
    domProps: {
      "innerHTML": _vm._s(_vm.productData.description)
    }
  })])])]), _vm._v(" "), _vm._l((_vm.typeList), function(type, index) {
    return _c('div', {
      key: index,
      staticClass: "pro_item_table"
    }, [_c('p', {
      staticClass: "pro_item_table_Title"
    }, [_vm._v(_vm._s(type.name))]), _vm._v(" "), _c('table', {
      staticClass: "table"
    }, [_c('thead', {
      staticClass: "thead_style"
    }, [_c('tr', [_vm._l((_vm.productData.attributes), function(column, index) {
      return _c('th', {
        key: index
      }, [_vm._v(" " + _vm._s(column.name))])
    }), _vm._v(" "), _c('th', [_vm._v("Colours")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("Actions")])], 2)]), _vm._v(" "), _c('tbody', {
      attrs: {
        "id": "customers"
      }
    }, _vm._l((_vm.productData.items), function(item, index) {
      return (item.type.id === type.id) ? _c('tr', {
        key: index
      }, [_vm._l((_vm.productData.attributes), function(column, indexColumn) {
        return _c('td', {
          key: indexColumn
        }, [_vm._v(_vm._s(item[column.slug]))])
      }), _vm._v(" "), (item.colors.length === 1) ? _c('td', {
        staticStyle: {
          "width": "250px"
        }
      }, [_vm._v(_vm._s(item.colors[0].name) + " "), _c('span', {
        staticClass: "color_dot",
        style: ({
          backgroundColor: item.colors[0].code
        })
      })]) : _vm._e(), _vm._v(" "), (item.colors.length > 1) ? _c('td', {
        staticStyle: {
          "width": "250px"
        }
      }, _vm._l((item.colors), function(color) {
        return _c('div', {
          key: color.id,
          staticClass: "aline_cl"
        }, [_c('div', [_c('md-radio', {
          staticClass: "cl_selct",
          attrs: {
            "value": color.id
          },
          model: {
            value: (_vm.selectedColor[index]),
            callback: function($$v) {
              _vm.$set(_vm.selectedColor, index, $$v)
            },
            expression: "selectedColor[index]"
          }
        }, [_vm._v(_vm._s(color.name))])], 1), _vm._v(" "), _c('div', [_c('span', {
          staticClass: "color_dot",
          style: ({
            backgroundColor: color.code
          })
        })])])
      }), 0) : _vm._e(), _vm._v(" "), _c('td', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('button', {
        staticClass: "btn btn-cart btn-sm",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.addtoCart(index, item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-shopping-cart",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Add to Cart")])])], 2) : _vm._e()
    }), 0)])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c8951c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/SingleProductView.vue
// module id = 2064
// module chunks = 1